import React from "react";

const Lost = () => {
  return <div>Lost Page</div>;
};

export default Lost;
